// extracted by mini-css-extract-plugin
export default {"statsContainer":"AdmissaoFilter_statsContainer__rLmpF","statsBox":"AdmissaoFilter_statsBox__zR6jP"};